var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567702137.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_vm._m(0), _c("div", {
    staticClass: "middle",
    attrs: {
      id: "map"
    }
  }), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "btns"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.openClick("知识库");
      }
    }
  }, [_vm._v("知识库")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.openClick("自助诊断");
      }
    }
  }, [_vm._v("自助诊断")]), _c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        return _vm.openClick("范蠡诊断");
      }
    }
  }, [_vm._v("范蠡诊断")])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("预警记录列表")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "table"
  }, [_vm._m(1), _c("div", {
    staticClass: "t-content"
  }, _vm._l(_vm.warn_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "tr",
      class: {
        active: index == _vm.active
      },
      on: {
        click: function click($event) {
          _vm.active = index;
        }
      }
    }, [index == _vm.active ? _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260730/1785403683241.png",
        alt: ""
      }
    }) : _vm._e(), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "100px"
      }
    }, [_vm._v(_vm._s(_vm.dayjs(item.createTime).format("YYYY-MM-DD")))]), _c("div", {
      staticClass: "td one-overflow",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.labName))]), _c("div", {
      staticClass: "td one-overflow",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.diseasesName))]), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "80px"
      }
    }, [_vm._v(_vm._s(item.caseCount))])]);
  }), 0)])])])])])]), _vm.show ? _c("div", {
    staticClass: "detail",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }, [_c("div", {
    staticClass: "pop",
    on: {
      click: function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("预警记录")]), _c("div", {
    staticClass: "close",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }, [_vm._v(" × ")])]), _c("div", {
    staticClass: "content"
  }, [_c("div", [_c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("日期：")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.dayjs(_vm.detail.createTime).format("YYYY-MM-DD")))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("企业名称：")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.labName))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("疾病名称：")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.diseasesName))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("患病数量：")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.caseCount))])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("疾病内容 ：")]), _c("div", {
    staticClass: "value"
  }, [_c("pre", [_vm._v(_vm._s(_vm.detail.diseasesContent))])])])])])])]) : _vm._e(), _vm.open ? _c("div", {
    staticClass: "detail",
    on: {
      click: function click($event) {
        _vm.open = false;
      }
    }
  }, [_c("div", {
    staticClass: "pop",
    staticStyle: {
      width: "80vw",
      height: "90vh",
      padding: "30px",
      background: "#fff"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("i", {
    staticClass: "close el-icon-error",
    staticStyle: {
      color: "#333",
      "font-size": "38px"
    },
    on: {
      click: function click($event) {
        _vm.open = false;
      }
    }
  }), _vm.openStr == "知识库" ? _c("iframe", {
    attrs: {
      src: "/knowledge",
      frameborder: "0"
    }
  }) : _vm._e(), _vm.openStr == "自助诊断" ? _c("iframe", {
    attrs: {
      src: "/diagnosis",
      frameborder: "0"
    }
  }) : _vm._e(), _vm.openStr == "范蠡诊断" ? _c("iframe", {
    attrs: {
      src: "https://guoyu-ai.rich-link.cn/dialogue_outer",
      frameborder: "0"
    }
  }) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "item item-1"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("疾病分类饼图")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart1"
    }
  })])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("疾病数量饼图")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart2"
    }
  })])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "100px"
    }
  }, [_vm._v("日期")]), _c("div", {
    staticClass: "td"
  }, [_vm._v("企业名称")]), _c("div", {
    staticClass: "td"
  }, [_vm._v("疾病名称")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "80px"
    }
  }, [_vm._v("患病数量")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };